import { render, staticRenderFns } from "./sign_agreements.vue?vue&type=template&id=5242ab5b&"
import script from "./sign_agreements.vue?vue&type=script&lang=js&"
export * from "./sign_agreements.vue?vue&type=script&lang=js&"
import style0 from "./sign_agreements.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5242ab5b')) {
      api.createRecord('5242ab5b', component.options)
    } else {
      api.reload('5242ab5b', component.options)
    }
    module.hot.accept("./sign_agreements.vue?vue&type=template&id=5242ab5b&", function () {
      api.rerender('5242ab5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/agreements/sign_agreements.vue"
export default component.exports